import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { computed } from '@ember/object';
export default ProtoBaseModel.extend({
  enableNegativeStockWarning: attr(Boolean),
  displayValueTranslationKey: computed('enableNegativeStockWarning', function () {
    return this.enableNegativeStockWarning ? 'business.devices.profiles.v2.common.on' : 'business.devices.profiles.v2.common.off';
  })
});